import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isHomePath } from '../i18n/localePath';
import Hero from './Hero';
import ContextFriendSection from './ContextFriendSection';
import WorkSection from './WorkSection';
import About from './About';
import FAQ from './FAQ';
import Contact from './Contact';

/**
 * Homepage composition. One product owns the hierarchy:
 *
 * Hero, ContextFriend, other projects, founder and company credentials,
 * practical FAQ (mirrored in index.html JSON-LD), and contact.
 */
const HomePage: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const target = document.querySelector(location.hash);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }

    if (isHomePath(location.pathname) && !location.hash) {
      window.scrollTo(0, 0);
    }
  }, [location.hash, location.pathname]);

  return (
    <>
      <Hero />
      <ContextFriendSection />
      <WorkSection />
      <About />
      <FAQ />
      <Contact />
    </>
  );
};

export default HomePage;
